import PropTypes from 'prop-types';
import UngroupedSpecialties from './ungrouped_specialties';
import GroupedSpecialties from './grouped_specialties';
import React from 'react';
import { specialtiesPropTypes } from './shared';

export default function Specialties({
  allBrokerSpecialties,
  groupSpecialties,
  pcUser = false,
  showSpecialtiesOnBrokerPlugin,
  userSpecialties
}) {
  let component =
    <UngroupedSpecialties
      allBrokerSpecialties={allBrokerSpecialties}
      pcUser={pcUser}
      showSpecialtiesOnBrokerPlugin={showSpecialtiesOnBrokerPlugin}
      userSpecialties={userSpecialties}
    />;

  if (groupSpecialties) {
    component =
      <GroupedSpecialties
        allBrokerSpecialties={allBrokerSpecialties}
        pcUser={pcUser}
        showSpecialtiesOnBrokerPlugin={showSpecialtiesOnBrokerPlugin}
        userSpecialties={userSpecialties}
      />;
  }

  return (
    <React.Fragment>
      <h2 className="top-buffer-lg">Specialties</h2>
      {component}
    </React.Fragment>
  );
}

Specialties.propTypes = {
  ...specialtiesPropTypes,
  groupSpecialties: PropTypes.bool.isRequired,
  pcUser: PropTypes.bool
};
